"use client"
import { detectIsInEgypt, formatHotlineValue } from "@/app/utils/helperFunctions"
import dynamic from "next/dynamic"
import { useEffect, useState } from "react"

const MapSection = dynamic(() => import("./MapSection"), {
	ssr: false,
	loading: () => (
		<div className="w-full h-full min-h-[44rem] bg-oSilver-60" aria-hidden />
	),
})

interface Child {
	id: number
	name?: string
	[key: string]: any
}
interface ContactInfo {
	title: {
		en: string
	}
	sub_title: {
		en: string
	}
	id: number
	children?: Child[]
	button_1_text?: {
		en: string
	}

}

interface ContactUsInfoProps {
	data: ContactInfo[]
}
const ContactUsInfo = ({ data }: ContactUsInfoProps) => {
	const [isInEgypt, setIsInEgypt] = useState(true)

	useEffect(() => {
		setIsInEgypt(detectIsInEgypt())
	}, [])

	const getDisplayValue = (info: ContactInfo) => {
		const value = info.sub_title.en
		if (info.title.en.toLowerCase() === "hotline") {
			return formatHotlineValue(value, isInEgypt)
		}
		return value
	}

	return (
		<div className="contact_us">
			<div className="flex flex-col lg:flex-row justify-between w-[100%]">
				<div className="contact_us_info px lg:pt-[5.17rem] pt-[4rem] pb-[4.75rem] w-[100%] lg:w-[50%] ">
					<div className="text-h5  mb-[2.5rem] lg:mb-[4.5rem]">
						Contact Info
					</div>
					<div className="contact_us_info_container flex flex-col gap-[2rem]">
						{data?.toReversed().map((info, index) => (
							<div key={index} className="flex flex-row">
								<div className="label flex-col w-[50%] lg:w-[30%] font-national text-oBlack-60 text-bodyM tracking-[0.04rem] ">
									{info.title.en}
								</div>
								{info.button_1_text ? (
									<div className={`value font-national flex-col w-[50%] lg:w-[50%] text-bodyM cursor-pointer lining-nums proportional-nums ${info.title.en.toLowerCase() === "hotline" ? "min-h-[1.5rem]" : ""}`}>
										<a
											href={
												info.button_1_text.en == "email"
													? `mailto:${info.sub_title.en}`
													: `tel:${getDisplayValue(info)?.replace(" ", "")}`
											}
											target="_blank"
											className="underline"
										>
											{getDisplayValue(info)}
										</a>
									</div>
								) : (
									<div className="value font-national flex-col w-[50%] lg:w-[50%] text-bodyM lining-nums proportional-nums">
										{getDisplayValue(info)}
									</div>
								)}
							</div>
						))}
					</div> 
				</div>
				<div className="contact_us_map w-[100%] lg:w-[50%] min-h-[44rem]">
					<MapSection data={data} />
				</div>
			</div>
		</div>
	)
}

export default ContactUsInfo
